import * as R from 'ramda'
import * as React from 'react'

import PropTypes from 'prop-types'

export function NodapayObserver(props) {
  React.useEffect(() => {
    const query = R.pathOr({}, ['query'], props)
    localStorage.setItem('nodapayMessage', JSON.stringify(query))

    // If the processing-step was opened in a new browser/tab close the window
    if (window.top === window.self) {
      window.close()
    }
  })

  return null
}

NodapayObserver.propTypes = {
  query: PropTypes.object,
}
